 <div class="container">
    <h1>Dados da Vistoria</h1>
    <br/>
    <div class="row">
        <div class="column">
            <strong>Tipo de Vistoria</strong><br/>
            {{getSurveyType()}}<br/><br/>
        </div>
        <div class="column">
            <strong>Motivo da Vistoria</strong><br/>
            {{getSurveyReason()}}<br/><br/>
        </div>
    </div>
    
    
</div>